module.exports = __webpack_public_path__ + "components/outside-promo-page/static/close-74cc1e6d0ae0bf854d3d26a5670cd802.svg";